import './styles.scoped.css'
import {useEffect, useState} from 'react'
import {
    Typography,
    Button,
    TextField,
    Checkbox,
    FormControlLabel,
    Radio,
    RadioGroup,
    Collapse,
    FormGroup,
    IconButton,
    Chip,
    Avatar,
    Tabs,
    Tab,
} from '@mui/material'
import {ArrowBack, Add} from '@mui/icons-material'
import {clientApi} from '../../services'
import {useGlobalStates} from '../../contexts/GlobalStatesContext'
import {useNavigate, Link, useParams} from 'react-router-dom'
import {useForm, Controller} from 'react-hook-form'
import {yupResolver} from '@hookform/resolvers/yup'
import * as yup from 'yup'
import {getInitials, getColorFromName, parseError, ignoreTimezone} from '../../utils/helpers'
import {useMobile} from '../../hooks'
import {DatePicker} from '@mui/x-date-pickers/DatePicker'
import {AgreementOverview, ScheduleHistory} from './components'
import {format} from 'date-fns'
import {SkeletonContainer, TextSkeleton, ChipSkeleton, AvatarSkeleton} from '../../components'

const MainCardSkeleton = ({mobile}) => (
    <SkeletonContainer>
        <div className="main-card">
            {mobile ? (
                <>
                    <TextSkeleton width={130} fontSize={18} />
                    <div className="content">
                        <TextSkeleton width={250} fontSize={18} />
                    </div>
                </>
            ) : (
                <>
                    <div className="content">
                        <TextSkeleton width={130} fontSize={20} />
                        <TextSkeleton width={6} fontSize={20} sx={{mx: 1.5}} />
                        <TextSkeleton width={280} fontSize={20} />
                    </div>
                    <br />
                </>
            )}
            <div className="main-content">
                <div className="main-content-profile">
                    <AvatarSkeleton size={mobile ? 56 : 64} />
                    <div className="main-content-profile-name">
                        <TextSkeleton width={mobile ? 120 : 160} fontSize={mobile ? 16 : 20} />
                        <TextSkeleton width={mobile ? 96 : 120} fontSize={mobile ? 14 : 16} />
                    </div>
                </div>
                {!mobile && (
                    <div className="main-content-status">
                        <div className="main-content-status-top">
                            <TextSkeleton width={200} fontSize={16} />
                            <ChipSkeleton width={68} height={32} />
                        </div>
                        <TextSkeleton width={170} />
                    </div>
                )}
            </div>
            {mobile && (
                <div className="main-content-status-top">
                    <TextSkeleton width={200} fontSize={16} />
                    <ChipSkeleton width={68} height={32} />
                </div>
            )}
        </div>
    </SkeletonContainer>
)

export default () => {
    const [serviceAgreement, setServiceAgreement] = useState(null)
    const [serviceItem, setServiceItem] = useState(null)
    const [service, setService] = useState({first_name: 'Amelia', last_name: 'Christine', avatar_url: null, pmi: '1233232'})
    const [tab, setTab] = useState(0)
    const [skeleton, setSkeleton] = useState(true)
    const {setMessageBox} = useGlobalStates()
    const navigate = useNavigate()
    const {mobile} = useMobile()
    const {clientId, serviceAgreementId, serviceId} = useParams()

    useEffect(() => {
        setSkeleton(true)
        clientApi
            .getServiceAgreement(clientId, serviceAgreementId)
            .then(({data: {data}}) => {
                setSkeleton(false)
                if (data) {
                    setServiceAgreement(data)
                    if (data?.service_items && data?.service_items?.length > 0) {
                        setServiceItem(data?.service_items?.find(item => item?.id == serviceId))
                    }
                }
            })
            .catch(error => {
                setSkeleton(false)
                const {title, description} = parseError(error)
                if (description) {
                    setMessageBox({status: 'error', title, description})
                }
            })
    }, [])

    return (
        <>
            {mobile ? (
                <>
                    <div className="header">
                        <Link to={`/clients-management-nosublayout/${clientId}/service-agreement/view-service-agreement/${serviceAgreementId}`}>
                            <IconButton>
                                <ArrowBack />
                            </IconButton>
                        </Link>
                        <Typography variant="h6" color="text.primary">
                            View Service Details
                        </Typography>
                    </div>
                    <br />
                </>
            ) : (
                <>
                    <Typography variant="body1" color="text.secondary">
                        <Link className="link" to="/clients-management">
                            Clients Management
                        </Link>
                        {' / '}
                        <Link className="link" to={`/clients-management/${clientId}/service-agreement`}>
                            Service Agreement
                        </Link>
                        {' / '}
                        <Link
                            className="link"
                            to={`/clients-management-nosublayout/${clientId}/service-agreement/view-service-agreement/${serviceAgreementId}`}>
                            View Service Agreement
                        </Link>{' '}
                        / View Service Details
                    </Typography>
                    <br />
                    <div className="back-container">
                        <Link
                            className="back-button"
                            to={`/clients-management-nosublayout/${clientId}/service-agreement/view-service-agreement/${serviceAgreementId}`}>
                            <ArrowBack style={{color: '#ffffff'}} fontSize="small" />
                        </Link>
                        <Typography variant="h5" color="text.primary">
                            View Service Details
                        </Typography>
                    </div>
                </>
            )}
            <br />
            <br />
            {skeleton ? (
                <MainCardSkeleton mobile={mobile} />
            ) : mobile ? (
                <>
                    <div className="main-card">
                        <Typography variant="h7" color="primary">
                            {serviceItem?.service_name}
                        </Typography>
                        <div className="content">
                            <Typography variant="h7" color="text.primary">
                                Service Agreement No.: {serviceAgreement?.agreement_number}
                            </Typography>
                            {/* <Typography variant="h7" color="text.primary">
                                Service Agreement No.: -
                            </Typography>
                            <Typography variant="h7" color="error">
                                (No billing)
                            </Typography> */}
                        </div>
                        <div className="main-content">
                            <div className="main-content-profile">
                                {serviceAgreement?.avatar_url ? (
                                    <Avatar src={serviceAgreement?.avatar_url} style={{width: 56, height: 56}} />
                                ) : (
                                    <Avatar
                                        style={{
                                            backgroundColor: getColorFromName(serviceAgreement?.client_name),
                                            width: 56,
                                            height: 56,
                                            fontSize: 28,
                                        }}>
                                        {getInitials(serviceAgreement?.client_name)}
                                    </Avatar>
                                )}
                                <div className="main-content-profile-name">
                                    <Typography variant="h8" color="text.primary">
                                        {serviceAgreement?.client_name}
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary">
                                        PMI: {serviceAgreement?.client_ma_number}
                                    </Typography>
                                </div>
                            </div>
                        </div>
                        <div className="main-content-status-top">
                            {serviceItem?.status == 'active' ? (
                                <>
                                    <Typography variant="h8" color="success">
                                        {serviceItem?.total_units == 0
                                            ? 0
                                            : Math.round((100 * serviceItem?.remaining_units) / serviceItem?.total_units)}
                                        % available ({serviceItem?.total_units} units)
                                    </Typography>
                                    <Chip label="Active" color="success" />{' '}
                                </>
                            ) : (
                                <Chip label="Not Active" color="error" />
                            )}
                        </div>
                    </div>
                </>
            ) : (
                <>
                    <div className="main-card">
                        <div className="content">
                            <Typography variant="h6" color="primary">
                                {serviceItem?.service_name}
                            </Typography>
                            <Typography variant="h6" color="text.primary" style={{marginLeft: 12, marginRight: 12}}>
                                |
                            </Typography>
                            <Typography variant="h6" color="text.primary">
                                Service Agreement No.: {serviceAgreement?.agreement_number}
                            </Typography>
                            {/* <Typography variant="h6" color="text.primary">
                                Service Agreement No.: -
                            </Typography>
                            <Typography variant="h6" color="error">
                                (No billing)
                            </Typography> */}
                        </div>
                        <br />
                        <div className="main-content">
                            <div className="main-content-profile">
                                {serviceAgreement?.avatar_url ? (
                                    <Avatar src={serviceAgreement?.avatar_url} style={{width: 64, height: 64}} />
                                ) : (
                                    <Avatar
                                        style={{
                                            backgroundColor: getColorFromName(serviceAgreement?.client_name),
                                            width: 64,
                                            height: 64,
                                            fontSize: 32,
                                        }}>
                                        {getInitials(serviceAgreement?.client_name)}
                                    </Avatar>
                                )}
                                <div className="main-content-profile-name">
                                    <Typography variant="h6" color="text.primary">
                                        {serviceAgreement?.client_name}
                                    </Typography>
                                    <Typography variant="body1" color="text.secondary">
                                        PMI: {serviceAgreement?.client_ma_number}
                                    </Typography>
                                </div>
                            </div>
                            <div className="main-content-status">
                                <div className="main-content-status-top">
                                    {serviceItem?.status == 'active' ? (
                                        <>
                                            <Typography variant="h8" color="success">
                                                {serviceItem?.total_units == 0
                                                    ? 0
                                                    : Math.round((100 * serviceItem?.remaining_units) / serviceItem?.total_units)}
                                                % available ({serviceItem?.total_units} units)
                                            </Typography>
                                            <Chip label="Active" color="success" />
                                        </>
                                    ) : (
                                        <Chip label="Not Active" color="error" />
                                    )}
                                </div>
                                <Typography variant="body2" color="text.primary">
                                    {format(new Date(ignoreTimezone(serviceAgreement?.effective_date) ?? null), 'MM/dd/yyyy') +
                                        ' - ' +
                                        format(new Date(ignoreTimezone(serviceAgreement?.through_date) ?? null), 'MM/dd/yyyy')}
                                </Typography>
                            </div>
                        </div>
                    </div>
                </>
            )}
            <br />
            <br />
            <div className="tab-container">
                <Tabs value={tab} onChange={(e, newValue) => setTab(newValue)} variant="fullWidth">
                    <Tab label="Agreement Overview" />
                    <Tab label="Schedule History" />
                </Tabs>
                <br />
                <div style={{display: tab != 0 ? 'none' : 'block'}}>
                    <AgreementOverview serviceAgreement={serviceAgreement} serviceItem={serviceItem} skeleton={skeleton} />
                </div>
                <div style={{display: tab != 1 ? 'none' : 'block'}}>
                    <ScheduleHistory />
                </div>
            </div>
            <br />
            <br />
            <br />
            <br />
            <br />
        </>
    )
}
